// ======================================================================
// 📁 File: src/components/common/Pagination.jsx
// 📝 Purpose: Reusable pagination component for Ticket/Visitor/Task modules
// 🕒 Created on: 2025-11-29 21:40 IST
// ======================================================================

import React from "react";

export default function Pagination({
  page = 1,
  pageSize = 10,
  total = 0,
  onPageChange,
}) {
  const totalPages = Math.ceil(total / pageSize);

  return (
    <div className="d-flex justify-content-between align-items-center p-2">
      {/* Left side summary */}
      <div className="small text-muted">
        Page {page} of {totalPages} • {total} records
      </div>

      {/* Right side buttons */}
      <div>
        <button
          className="btn btn-sm btn-outline-secondary me-2"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
        >
          Previous
        </button>

        <button
          className="btn btn-sm btn-outline-secondary"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
}
